import { useEffect } from "react";
import { FC } from "react";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";

import TopNav from "../../components/TopNav/TopNav";
import Button from "../../components/Button/Button";
import Title from "../../components/Title/Title";
import { UpdateIcon } from "../../components/icons/UpdateIcon";
import ContentLayout from "../../layout/ContentLayout/ContentLayout";
import {
  selectActiveCompetitorsState,
  selectBrandLoading,
  selectBrandLoadError,
  selectInactiveCompetitorsState,
} from "../../store/selectors/brands";
import { TitleWithFormRelatedBrands } from "../../components";
import { fetchBrands, addCompetitor } from "../../store/brands/slice";
import CardSwitchCompetitorsWrapper from "../../components/CardSwitchCompetitorsWrapper/CardSwitchCompetitorsWrapper";
import { AddFormItem } from "../../components/AddForm/types";

import styles from "./SettingCompetitors.module.css";



const SettingCompetitorsView: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(selectBrandLoading);
  const loadError = useSelector(selectBrandLoadError);
  const activeCompetitors = useSelector(selectActiveCompetitorsState);
  const inactiveCompetitors = useSelector(selectInactiveCompetitorsState);


  useEffect(() => {
    dispatch(fetchBrands());
  }, [dispatch]);

  const closePromptsSettings = () => {
    navigate(-1);
  };

  const renderTopNavRightContent = () => {
    return (
      <div className={styles["modal"]}>
        {loading && <p className={styles["modal__changed"]}><UpdateIcon /> changes saved</p>}
        <Button label="Close" onClick={closePromptsSettings} />
      </div>
    );
  };

  const handleAddCompetitors = (item: AddFormItem) => {
    const { label: name, data } = item;
    dispatch(addCompetitor({
      name,
      logoUrl: data?.logo_url,
      website: data?.domain ?? data?.website_url,
    }));
  };

  return (
    <>
      <TopNav title="Competitors Settings" rightContent={renderTopNavRightContent()} />
      <ContentLayout>
        <TitleWithFormRelatedBrands
          className={styles["title-add"]}
          label="Active Competitors"
          onAddItem={handleAddCompetitors}
          placeholder="Add a new competitor"
        />

          <CardSwitchCompetitorsWrapper
            competitors={activeCompetitors}
            active={true}
            skeletonCount={3}
            loading={loading}
            error={loadError}
            onRetry={() => dispatch(fetchBrands())}
          />

        {inactiveCompetitors && inactiveCompetitors.length > 0 && <Title className={styles["title"]} label="Inactive Competitors" />}
        
        <CardSwitchCompetitorsWrapper
          competitors={inactiveCompetitors}
          active={false}
          skeletonCount={3}
          loading={loading}
          error={loadError}
          onRetry={() => dispatch(fetchBrands())}
        />

      </ContentLayout>

    </>
  );
}

export default SettingCompetitorsView;
